import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, User, LogOut } from 'lucide-react';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <header className="header">
      <div className="header-inner" style={{ position: 'relative' }}>
        <Link to="/" className="logo">
          <div className="logo-icon">
            <img src="/favicon_io/android-chrome-192x192.png" alt="ILoveConvert" />
          </div>
          ILove<span>Convert</span>
        </Link>

        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/qr-code-generator" onClick={() => setMenuOpen(false)}>QR Code</Link>
          <Link to="/merge-pdf" onClick={() => setMenuOpen(false)}>PDF Tools</Link>
          <Link to="/image-convert" onClick={() => setMenuOpen(false)}>Image Tools</Link>
          <Link to="/remove-background" onClick={() => setMenuOpen(false)}>Remove Background</Link>
          <Link to="/merge-pdf" onClick={() => setMenuOpen(false)}>Merge PDF</Link>
          
          {token ? (
            <>
              <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="btn btn-outline btn-sm">
                <User size={14} /> Dashboard
              </Link>
              <button onClick={() => { handleLogout(); setMenuOpen(false); }} className="btn btn-sm" style={{ background: '#fee2e2', color: '#dc2626', border: 'none' }}>
                <LogOut size={14} /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setMenuOpen(false)} className="btn btn-outline btn-sm">Login</Link>
              <Link to="/register" onClick={() => setMenuOpen(false)} className="btn btn-primary btn-sm">Sign Up Free</Link>
            </>
          )}
        </nav>

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
}
